($ => {

    $(document).ready(() => {
        $(document).on("click", ".cesta-card-palestrante .btn-remover", async function () {
            let cardsContainer = null;
            try {
                cardsContainer = $(this).closest(".cesta-card-palestrante").parent();
                $(cardsContainer).find(".cesta-card-palestrante .btn-remover").prop("disabled", true);
                let palestranteId = parseInt($(this).data("id")) || 0;
                const responseHTML = await ServerActions.get("remove_palestrante_orcamento", { pid: palestranteId });
                Events.dispatch(ServerEvents.REMOVE_PALESTRANTE_ORCAMENTO, [ responseHTML ]);
            } catch (error) {
                UIMessages.error("Erro ao remover palestrante da cesta.", ".cesta-card-palestrante");
            } finally {
                $(cardsContainer).find(".cesta-card-palestrante .btn-remover").prop("disabled", false);
            }
        });
    });

})(jQuery);
